export const iconFontAwesomeMusicVideoVolumeLow = (
	<i className="fa-solid fa-volume-low"></i>
);
